import { serialize } from 'object-to-formdata';
import { IUserForm, IUserPatchResponse } from 'types/forms/user';
import { IUserAreaPermissionsPayload } from 'types/forms/userAreaPermissions';
import { IUserResponse, IUsersResponse } from 'types/user';
import request from './index';

/** Bez tego multipart nie przekazuje pustych `area_ids[]` / `function_ids[]` → Rails nie czyści assoc. */
function serializeUserMultipart(data: IUserForm) {
  return serialize(data, { allowEmptyArrays: true });
}

export const getUsers = () =>
  request<IUsersResponse>({
    options: {
      url: '/users',
      method: 'get'
    }
  });

export const getUser = (id: string) =>
  request<IUserResponse>({
    options: {
      url: `/users/${id}`,
      method: 'get'
    }
  });

export const createUser = (data: IUserForm) =>
  request<IUserPatchResponse>({
    options: {
      url: '/users',
      method: 'post',
      data: serializeUserMultipart(data)
    },
    headers: { 'Content-Type': 'multipart/form-data' }
  });

export const editUser = (id: string | number, data: IUserForm) =>
  request<IUserPatchResponse>({
    options: {
      url: `/users/${id}`,
      method: 'patch',
      data: serializeUserMultipart(data)
    },
    headers: { 'Content-Type': 'multipart/form-data' }
  });

export const lockUserAccess = (id: string | number) =>
  request<IUserPatchResponse>({
    options: {
      url: `/users/${id}/lock_access`,
      method: 'patch'
    }
  });

export const unlockUserAccess = (id: string | number) =>
  request<IUserPatchResponse>({
    options: {
      url: `/users/${id}/unlock_access`,
      method: 'patch'
    }
  });

export const getMe = () =>
  request<IUserResponse>({
    options: {
      url: '/account/me',
      method: 'get'
    }
  });

export const updateAccount = (data: IUserForm) =>
  request<IUserPatchResponse>({
    options: {
      url: '/account',
      method: 'patch',
      data: serializeUserMultipart(data)
    },
    headers: { 'Content-Type': 'multipart/form-data' }
  });

export const updateUserAreaPermissions = (
  userId: string | number,
  payload: IUserAreaPermissionsPayload
) =>
  request<IUserPatchResponse>({
    options: {
      url: `/users/${userId}/area_permissions`,
      method: 'patch',
      data: payload
    }
  });
